import { lazy, Suspense } from 'react';
export function lazyLoadRoutes(componentName) {  
  const LazyElement = lazy(() => import(`../features/${componentName}/index.js`));
  return (
    <Suspense>
      <LazyElement />
    </Suspense>
  );
}
